import i18n from 'i18n';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { SnmpDestination } from 'data/snmp/snmp.types';

export enum SnmpDestActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newSnmpDest: SnmpDestination = {
  id: '',
  DESTID: '',
  NAME: '',
  VERSION: 'SNMPV3',
  SECURITYNAME: '',
  DESTIP: '',
  DESTPORT: '162',
  OWNIP: '',
  OWNPORT: '0',
  REQSTATE: 'ACTIVE'
};

export const snmpDestColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('snmpDest.grid.destID'),
    field: 'DESTID',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'name',
    flex: 1,
    minWidth: 165,
    maxWidth: 165
  },
  {
    headerName: i18n.t('snmpDest.grid.name'),
    field: 'NAME',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'description',
    flex: 1,
    minWidth: 165,
    maxWidth: 165
  },
  {
    headerName: i18n.t('snmpDest.grid.version'),
    field: 'VERSION',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'description',
    flex: 1,
    minWidth: 165,
    maxWidth: 165
  },
  {
    headerName: i18n.t('snmpDest.grid.securityName'),
    field: 'SECURITYNAME',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'description',
    flex: 1,
    minWidth: 165,
    maxWidth: 165
  },
  {
    headerName: i18n.t('snmpDest.grid.destinationIP'),
    field: 'DESTIP',
    sortable: true,
    resizable: true,
    tooltipField: 'intfType',
    flex: 1,
    minWidth: 165,
    maxWidth: 165,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
  {
    headerName: i18n.t('snmpDest.grid.destinationPort'),
    field: 'DESTPORT',
    sortable: true,
    resizable: true,
    tooltipField: 'tlsVersion',
    flex: 1,
    minWidth: 165,
    maxWidth: 165,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
  {
    headerName: i18n.t('snmpDest.grid.ownIp'),
    field: 'OWNIP',
    sortable: true,
    resizable: true,
    tooltipField: 'tlsVersion',
    flex: 1,
    minWidth: 165,
    maxWidth: 165,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
  {
    headerName: i18n.t('snmpDest.grid.ownPort'),
    field: 'OWNPORT',
    sortable: true,
    resizable: true,
    tooltipField: 'tlsVersion',
    flex: 1,
    minWidth: 165,
    maxWidth: 165,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
  {
    headerName: i18n.t('snmpDest.grid.reqstate'),
    field: 'REQSTATE',
    sortable: true,
    resizable: true,
    tooltipField: 'tlsVersion',
    flex: 1,
    minWidth: 165,
    maxWidth: 165,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
];
